import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const Loader = props => {
  const { isActive } = props;
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={isActive}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

Loader.defaultProps = {
  isActive: false,
};

Loader.propTypes = {
  isActive: PropTypes.bool,
};

export default Loader;
